var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5342 2.54541V3.12874C11.5342 4.22869 11.5342 4.77866 11.1925 5.12037C10.8507 5.46208 10.3008 5.46208 9.20085 5.46208H8.32585M8.32585 5.46208L9.78418 4.29541M8.32585 5.46208L9.78418 6.62874",
    stroke: "url(#paint0_linear_7478_7418)",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43111 3.31318L5.8097 3.99155C6.15136 4.60375 6.01421 5.40685 5.47609 5.94496C5.47609 5.94496 4.82344 6.59771 6.00681 7.78112C7.18981 8.96412 7.84296 8.31183 7.84296 8.31183C8.38109 7.77371 9.18416 7.63657 9.79637 7.97823L10.4747 8.35681C11.3992 8.87271 11.5083 10.1691 10.6958 10.9817C10.2076 11.4699 9.60941 11.8499 8.9482 11.8749C7.83515 11.9171 5.94486 11.6354 4.04867 9.73925C2.15251 7.84307 1.8708 5.95279 1.913 4.83971C1.93807 4.17851 2.31798 3.58038 2.80624 3.09213C3.61879 2.27957 4.9152 2.38875 5.43111 3.31318Z",
    fill: "url(#paint1_linear_7478_7418)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7478_7418",
    x1: 8.70129,
    y1: 2.62103,
    x2: 12.0775,
    y2: 3.81364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75FD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7478_7418",
    x1: 10.1503,
    y1: 2.71825,
    x2: 0.960618,
    y2: 6.8498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75FD0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.53ce79df644284aed0da3dee735d4f0c.svg";
export { ForwardRef as ReactComponent };